import { v4 as uuidv4 } from 'uuid'

export const complianceLegalDisclosuresTestData = {
  title: 'Compliance / Legal Disclosures',
  item: '1 Disclosure',
  key: uuidv4()
}
